import { GenericBackendResponse } from '../genericBackendResponse';
import { FullCompanyResponseData } from './interfaces/CompanyInfo';

const getCompanyInfoEppConfig = async (
	token: string,
	companyId: string
): Promise<GenericBackendResponse<FullCompanyResponseData>> => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/companies/full-company`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	});

	return response.json();
};

export default getCompanyInfoEppConfig;
